// @TODO Add SignalR to update status in real time

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, filter, first, interval, takeUntil, takeWhile, withLatestFrom } from 'rxjs';
import { ApiState } from '../../model/api-state.model';
import { PaymentState } from '../../model/payment-state.model';
import { ProcessService } from '../../services/process.service';
import { AppState } from '../../store';
import * as fromPayments from '../../store/payments/payments.reducer';
import * as fromProcess from '../../store/process/process.reducer';

const REFRESH_INTERVAL = 5000;

@Component({
  selector: 'app-page-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.scss'],
})
export class PaymentStatusComponent implements OnInit, OnDestroy {
  paymentsTransactionState$ = this.store.select(fromPayments.selectPaymentsTransactionState);
  paymentsTransactionStatePrev$ = this.store.select(fromPayments.selectPaymentsTransactionStatePrev);
  paymentsTransactionDate$ = this.store.select(fromPayments.selectPaymentsTransactionData);
  paymentsTransactionResult$ = this.store.select(fromPayments.selectPaymentsTransactionResult);
  paymentsTransactionError$ = this.store.select(fromPayments.selectPaymentsTranscationError);
  paymentsTransactionErrorPrev$ = this.store.select(fromPayments.selectPaymentsTransactionErrorPrev);
  ngDestroy$ = new Subject<void>();
  apiState = ApiState;
  paymentState = PaymentState;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private processService: ProcessService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(fromProcess.actions.setStep({ step: 7 }));
    this.processService.onPageInit();
    this.store.dispatch(fromPayments.actions.resetOnStatus());

    const transactionGUID = this.activatedRoute.snapshot.paramMap.get('transactionGUID');

    if (typeof transactionGUID !== 'string') {
      throw new Error('transactionGUID is not a string');
    }

    this.store.dispatch(fromPayments.actions.fetchTransactionStart({ transactionGUID }));

    this.paymentsTransactionResult$
      .pipe(
        filter((status) => status === PaymentState.success),
        first(),
      )
      .subscribe(() => {
        this.store.dispatch(fromProcess.actions.setSuccess({ success: true }));

        void this.router.navigate(['/page/success']);
      });

    this.implementStatusRefresh();
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }

  handleTryAgain(): void {
    void this.router.navigate(['page', 'payment']);
  }

  private implementStatusRefresh() {
    const transactionGUID = this.activatedRoute.snapshot.paramMap.get('transactionGUID');

    if (typeof transactionGUID !== 'string') {
      throw new Error('transactionGUID is not a string');
    }

    interval(REFRESH_INTERVAL)
      .pipe(
        withLatestFrom(this.paymentsTransactionResult$),
        takeUntil(this.ngDestroy$),
        takeWhile(([_, paymentsTransactionResult]) => paymentsTransactionResult === PaymentState.pending),
      )
      .subscribe(() => {
        this.store.dispatch(fromPayments.actions.fetchTransactionStart({ transactionGUID }));
      });
  }
}
